/**
 * Design for the Analytics dashboard.
 */

export const BRAND = "#f58220";
export const BRAND_DARK = "#d97320";

export const analyticsTheme = {
  brand: BRAND,
  brandDark: BRAND_DARK,
  brandSoft: "#fff3e9",

  pageBg: "#f6f7f9",
  cardBg: "#ffffff",

  border: "#edeff2",
  borderStrong: "#e3e6eb",

  text: {
    primary: "#161a20",
    secondary: "#646b78",
    muted: "#9aa1ad",
  },

  radius: {
    sm: "10px",
    md: "16px",
    lg: "20px",
    pill: "999px",
  },

  shadow: {
    card: "0 1px 2px rgba(16,24,40,0.04), 0 1px 3px rgba(16,24,40,0.05)",
    cardHover: "0 8px 24px rgba(16,24,40,0.08), 0 2px 6px rgba(16,24,40,0.05)",
    pop: "0 12px 32px rgba(16,24,40,0.12)",
  },

  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
} as const;

export const KPI_ACCENTS = [
  { main: "#f58220", soft: "#fff3e9" }, // views — brand orange
  { main: "#2f6bff", soft: "#eaf0ff" }, // clicks — blue
  { main: "#16a571", soft: "#e7f7f0" }, // saves — green
  { main: "#8b5cf6", soft: "#f1ecfe" }, // CTR — violet
] as const;

export const cardSx = {
  backgroundColor: analyticsTheme.cardBg,
  border: `1px solid ${analyticsTheme.border}`,
  borderRadius: analyticsTheme.radius.md,
  boxShadow: analyticsTheme.shadow.card,
  transition: analyticsTheme.transition,
} as const;
